// @ts-ignore
import getImagePalette from 'image-palette-core'
import {useEffect, useState} from 'react'
import {useTrackListener} from './useTrackListener'

/*
  backgroundColor will be the most dominant color in the image.
  color will be the color that looks the best overlayed over backgroundColor.
  alternativeColor will be the second best color. If there are only two colors parsed, it will default to color.
*/

type Palette = {
  backgroundColor: string
  color: string
  alternativeColor: string
}

export const useTrackColors = () => {
  const [state, setState] = useState<Palette>()
  const track = useTrackListener()
  const url = track?.item.album.images.find(image => image.height === 640)?.url

  useEffect(() => {
    if (url) {
      let img: HTMLImageElement | null = new Image()
      img.src = url
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        const palette = getImagePalette(img) as Palette
        setState(palette)
      }

      return () => {
        img = null
      }
    }
  }, [url])

  return state
}
